"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsSubPackage = void 0;
const utils_1 = require("../logic/utils");
class UtilsSubPackage {
    constructor(signer, liquidStakingManagerAddress, frenDelegationBribeVaultAddress = '') {
        this.etherSigner = signer;
        this.liquidStakingManagerAddress = liquidStakingManagerAddress;
        this.frenDelegationBribeVaultAddress = frenDelegationBribeVaultAddress;
    }
    add0x(data) {
        return (0, utils_1._add0x)(data);
    }
    remove0x(data) {
        return (0, utils_1._remove0x)(data);
    }
    getDAOAddress() {
        return (0, utils_1._getDAOAddress)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    getSavETHVaultAddress() {
        return (0, utils_1._getSavETHVaultAddress)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    getFeesAndMEVPoolAddress() {
        return (0, utils_1._getFeesAndMEVPoolAddress)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    getStakehouseTicker() {
        return (0, utils_1._getStakehouseTicker)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    isWhitelistingEnabled() {
        return (0, utils_1._isWhitelistingEnabled)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    isNodeRunnerWhitelisted(nodeRunnerAddress) {
        return (0, utils_1._isNodeRunnerWhitelisted)(this.etherSigner, this.liquidStakingManagerAddress, nodeRunnerAddress);
    }
    getSmartWalletRepresentative(smartWalletAddress) {
        return (0, utils_1._getSmartWalletRepresentative)(this.etherSigner, this.liquidStakingManagerAddress, smartWalletAddress);
    }
    getSmartWalletOfKnot(blsPublicKey) {
        return (0, utils_1._getSmartWalletOfKnot)(this.etherSigner, this.liquidStakingManagerAddress, blsPublicKey);
    }
    getSmartWalletOfNodeRunner(nodeRunnerAddress) {
        return (0, utils_1._getSmartWalletOfNodeRunner)(this.etherSigner, this.liquidStakingManagerAddress, nodeRunnerAddress);
    }
    getNodeRunnerOfSmartWallet(smartWalletAddress) {
        return (0, utils_1._getNodeRunnerOfSmartWallet)(this.etherSigner, this.liquidStakingManagerAddress, smartWalletAddress);
    }
    getStakedKnotsOfSmartWallet(smartWalletAddress) {
        return (0, utils_1._getStakedKnotsOfSmartWallet)(this.etherSigner, this.liquidStakingManagerAddress, smartWalletAddress);
    }
    getSmartWalletDormantRepresentative(smartWalletAddress) {
        return (0, utils_1._getSmartWalletDormantRepresentative)(this.etherSigner, this.liquidStakingManagerAddress, smartWalletAddress);
    }
    isNodeRunnerBanned(nodeRunnerAddress) {
        return (0, utils_1._isNodeRunnerBanned)(this.etherSigner, this.liquidStakingManagerAddress, nodeRunnerAddress);
    }
    getNumberOfKnots() {
        return (0, utils_1._getNumberOfKnots)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    getDaoCommissionPercentage() {
        return (0, utils_1._getDaoCommissionPercentage)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    isBLSPublicKeyBanned(blsPublicKey) {
        return (0, utils_1._isBLSPublicKeyBanned)(this.etherSigner, this.liquidStakingManagerAddress, blsPublicKey);
    }
    deRegisterKnotsFromSyndicate(blsPublicKeys) {
        return (0, utils_1._deRegisterKnotsFromSyndicate)(this.etherSigner, this.liquidStakingManagerAddress, blsPublicKeys);
    }
    updateDaoAddress(newDaoAddress) {
        return (0, utils_1._updateDaoAddress)(this.etherSigner, this.liquidStakingManagerAddress, newDaoAddress);
    }
    updateDaoRevenueCommission(newDaoRevenueCommission) {
        return (0, utils_1._updateDaoRevenueCommission)(this.etherSigner, this.liquidStakingManagerAddress, newDaoRevenueCommission);
    }
    updateStakehouseTicker(newStakehouseTicker) {
        return (0, utils_1._updateStakehouseTicker)(this.etherSigner, this.liquidStakingManagerAddress, newStakehouseTicker);
    }
    updateWhitelisting(newWhitelistingStatus) {
        return (0, utils_1._updateWhitelisting)(this.etherSigner, this.liquidStakingManagerAddress, newWhitelistingStatus);
    }
    updateNodeRunnerWhitelistStatus(nodeRunnerAddresses, newWhitelistingStatus) {
        return (0, utils_1._updateNodeRunnerWhitelistStatus)(this.etherSigner, this.liquidStakingManagerAddress, nodeRunnerAddresses, newWhitelistingStatus);
    }
    rotateEOARepresentative(newRepresentativeAddress) {
        return (0, utils_1._rotateEOARepresentative)(this.etherSigner, this.liquidStakingManagerAddress, newRepresentativeAddress);
    }
    withdrawETHForKnot(recipientAddress, blsPublicKey) {
        return (0, utils_1._withdrawETHForKnot)(this.etherSigner, this.liquidStakingManagerAddress, recipientAddress, blsPublicKey);
    }
    claimRewardsAsNodeRunner(recipientAddress, blsPublicKeys) {
        return (0, utils_1._claimRewardsAsNodeRunner)(this.etherSigner, this.liquidStakingManagerAddress, recipientAddress, blsPublicKeys);
    }
    registerBLSPublicKeys(blsPublicKeys, blsSignatures, representativeAddress, ethValue) {
        return (0, utils_1._registerBLSPublicKeys)(this.etherSigner, this.liquidStakingManagerAddress, blsPublicKeys, blsSignatures, representativeAddress, ethValue);
    }
    stake(blsPublicKeys, cipherTexts, aesEncryptorKeys, encryptionSignatures, dataRoots) {
        return (0, utils_1._stake)(this.etherSigner, this.liquidStakingManagerAddress, blsPublicKeys, cipherTexts, aesEncryptorKeys, encryptionSignatures, dataRoots);
    }
    mintDerivatives(blsPublicKeys, beaconChainReports, authenticatedReportSignatures) {
        return (0, utils_1._mintDerivatives)(this.etherSigner, this.liquidStakingManagerAddress, blsPublicKeys, beaconChainReports, authenticatedReportSignatures);
    }
    getNetworkFeeRecipient() {
        return (0, utils_1._getNetworkFeeRecipient)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    toggleHouseGatekeeper(enable) {
        return (0, utils_1._toggleHouseGatekeeper)(this.etherSigner, this.liquidStakingManagerAddress, enable);
    }
    transferSmartWalletOwnership(newOwner) {
        return (0, utils_1._transferSmartWalletOwnership)(this.etherSigner, this.liquidStakingManagerAddress, newOwner);
    }
    recoverSigningKey(safeBoxAddress, nodeRunnerAddress, blsPublicKey, hAesPublicKey) {
        return (0, utils_1._recoverSigningKey)(this.etherSigner, this.liquidStakingManagerAddress, safeBoxAddress, nodeRunnerAddress, blsPublicKey, hAesPublicKey);
    }
    updateSyndicateActivationDistanceInBlocks(distance) {
        return (0, utils_1._updateSyndicateActivationDistanceInBlocks)(this.etherSigner, this.liquidStakingManagerAddress, distance);
    }
    getGateKeeperAddress() {
        return (0, utils_1._getGateKeeperAddress)(this.etherSigner, this.liquidStakingManagerAddress);
    }
    getFrenDelegationBribesByBLS(blsPublicKey) {
        return (0, utils_1._getFrenDelegationBribesByBLS)(this.etherSigner, this.frenDelegationBribeVaultAddress, blsPublicKey);
    }
}
exports.UtilsSubPackage = UtilsSubPackage;
